"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberString = exports.ObjectId = void 0;
const z = require("zod");
const _ = require("lodash");
const bson = require("bson");
exports.ObjectId = z.preprocess((obj) => (bson.ObjectId.isValid(obj) ? obj.toString() : obj), z.string()).refine((d) => bson.ObjectId.isValid(d) && d, (d) => ({ message: `Cannot parse input as ObjectId: ${d}`, path: ['ObjectId'] }));
const _isNumber = (n) => !_.isNaN(n);
exports.NumberString = z.preprocess((d) => Number(d), z.number()).refine((d) => _isNumber(d) && d, (d) => ({ message: `Cannot parse input as number: ${d}` }));
